module.exports = {"130209100":"唐海镇","130209112":"滨海镇","130209113":"柳赞镇","130209401":"一农场","130209403":"三农场","130209404":"四农场","130209405":"五农场","130209406":"六农场","130209407":"七农场","130209408":"八农场","130209409":"九农场","130209410":"十农场","130209411":"十一农场","130209412":"八里滩养殖场","130209413":"十里海养殖场","130209450":"南堡经济开发区","130209451":"曹妃甸工业区","130209452":"唐山湾生态城"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130209.json
// module id = 84
// module chunks = 0